@use "../../styles/breakpoint.module.scss" as *;
@use "../Clickables/index.module.scss" as *;

.productContainer {
    composes: dark from "../../styles/theming.module.css";
}

.productContainerInner {
    composes: container from "../../styles/composable/layout.module.css";
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacer-16);
    padding-top: var(--spacer-32);
    padding-bottom: var(--spacer-24);

    @media ($below-tablet) {
        display: contents;
    }
}

.titleWrapper {
    @media ($below-tablet) {
        display: none;
    }
}

.title {
    font: var(--font-h-34);
}

.titleInfo {
    display: flex;
    align-items: center;
    gap: var(--spacer-8);
    margin-top: var(--spacer-8);
}

.productTag {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    font: var(--font-eyebrow);
    translate: 0 1px;
}

.ctas {
    display: flex;
    gap: var(--spacer-16);
    flex-shrink: 0;

    @media ($below-tablet) {
        position: absolute;
        right: var(--spacer-24);
        top: 50%;
        translate: 0 -50%;
    }
}

.ctaTextDesktop {
    @media ($below-tablet) {
        display: none;
    }
}

.ctaTextMobile {
    @media ($above-tablet) {
        display: none;
    }
}

.navMenuFullBleed {
    composes: dark from "../../styles/theming.module.css";
    position: sticky;
    top: 0;

    // set to 11 with main nav's value of 10 in mind
    z-index: 11;
}

.navStatus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacer-16);

    @media ($above-tablet) {
        display: none;
    }

    @media ($below-tablet) {
        padding: var(--spacer-16) var(--spacer-24);
    }
}

.dealerButton {
    @media ($above-tablet) {
        padding-right: 20px;
    }
}

.navItems {
    @media ($below-tablet) {
        position: absolute;
        width: 100%;
        height: auto;
        max-height: 0;
        background-color: var(--medium-gray);
        transition: max-height 0.2s linear;
        overflow: hidden;

        &.navIsOpen {
            max-height: 50vh;
            overflow-y: scroll;
        }
    }
}

.navItemList {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    justify-content: center;

    @media ($below-tablet) {
        padding-block: var(--spacer-12);
        flex-direction: column;
    }
}
